import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import Page from 'components/PageStructure';

import FilledButton from 'components/Buttons/FilledButton';
import FilterField from 'components/FormGroup/FilterField';

import Toast from 'components/Informations/Toast';

import useFetch from 'hooks/useFetch';
import endpoints from 'services/endpoints';

import { MDBRow, MDBCol } from 'mdbreact';
import * as S from './styles';
import ClientsTable from './InternalComponents/ClientsTable';

const { getClients } = endpoints;

export default function Clients({ history }) {
  const [toastVisibility, setToastVisiblity] = useState(true);
  const [toastType, setToastType] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [toastTime, setToastTime] = useState(2000);

  const [clientSearched, setClientSearched] = useState('');
  const [clients, setClients] = useState([]);

  const [allClients] = useFetch(getClients);

  useEffect(() => {
    const toast =
      localStorage.getItem('successToast') !== null || undefined
        ? JSON.parse(localStorage.getItem('successToast'))
        : {};

    if (Object.keys(toast).length) {
      const {
        toastType: type,
        toastMessage: message,
        toastCloseTime: closeTime,
      } = toast;

      setToastVisiblity(true);
      setToastTime(closeTime);
      setToastMessage(message);
      setToastType(type);

      setTimeout(() => {
        setToastVisiblity(false);
        setToastMessage('');
        setToastType('');
      }, closeTime);
    }

    return () => {
      setToastTime(2000);
      setToastMessage('');
      setToastType('');
      localStorage.removeItem('successToast');
    };
  }, []);

  useEffect(() => {
    (async () => {
      const response = await allClients;
      setClients(response);
    })();
  }, [allClients]);

  const handleSearch = () => {
    const filteredClients =
      clients &&
      clients.filter(
        employee =>
          employee.nome.toLowerCase().indexOf(clientSearched.toLowerCase()) >=
          0,
      );

    return <ClientsTable clients={filteredClients} />;
  };

  return (
    <>
      {toastVisibility && (
        <Toast
          type={toastType}
          message={toastMessage}
          autoClose={toastTime}
          hideProgress
        />
      )}

      <Page
        title="Clientes"
        subtitle="Cadastre, visualize e altere informações dos clientes em nossa base."
      >
        <S.Actions>
          <div>
            <FilterField
              handleChange={e => setClientSearched(e.target.value)}
              value={clientSearched}
              name="filterEmployees"
              labelText="Deseja pesquisar um cliente em específico?"
              width={400}
              placeholderText="Insira o nome do cliente desejado"
              noTransparency={false}
            />
          </div>
          <FilledButton
            text="+ Adicionar novo cliente"
            buttonClass="success"
            handleClick={() => history.push('clients/add-client')}
          />
        </S.Actions>
        <MDBRow>
          <MDBCol lg="12">
            {clientSearched.length > 0 ? (
              handleSearch()
            ) : (
              <ClientsTable clients={clients} />
            )}
          </MDBCol>
        </MDBRow>
      </Page>
    </>
  );
}

Clients.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};
